/**
 * action types
 */

export const SET_MAIN_NAV_VISIBILITY = 'SET_MAIN_NAV_VISIBILITY'

/**
 * action creators
 */

/**
 * @param {Boolean} visible
 */
export function setMainNavVisibility(visible) {
  return {
    type: SET_MAIN_NAV_VISIBILITY,
    visible,
  }
}
